import React from 'react';
import { Text, Stack, Flex, Dot } from '@pairy/pds-react';

import { TrackingLinkClient } from '@/hooks/queries/client/useClientTrackList';
import { getUTCDate } from '@/utils/getUTCDate';
import Star from '@/components/User/_components/common/Star';
import { formatKoreanPhoneNumber } from '@/utils/formatPhone';

import * as Styled from './index.styles';

interface Props
  extends Omit<
    TrackingLinkClient,
    'hashId' | 'isShared' | 'attentionRate' | 'isBlurred' | 'company' | 'phone'
  > {
  company?: TrackingLinkClient['company'];
  phone?: TrackingLinkClient['phone'];
  rightIcon?: React.ReactNode;
  onClick: () => void;
}

const Client = ({
  id,
  name,
  company,
  phone,
  isChecked,
  like,
  readCount,
  lastAction,
  rightIcon,
  onClick,
  priorReadCount,
}: Props) => {
  return (
    <Styled.BoxWrapper onClick={onClick} rightIcon={rightIcon}>
      <Stack gap={8}>
        <div>
          <Dot
            color={isChecked ? 'transparent' : 'vermillion_400'}
            marginTop={5}
            marginRight={5}
            marginBottom={5}
            marginLeft={5}
          />
        </div>

        <Stack direction="column" gap={8}>
          <Stack alignItems="center" gap={4}>
            <Text as="p" variant="md-bold">
              {name ||
                company ||
                (phone ? formatKoreanPhoneNumber(phone) : null) ||
                '(이름 없음)'}
            </Text>
            <Star like={like} clientId={id} />
          </Stack>

          <Stack gap={8} alignItems="center" width="fit-content">
            {readCount && (
              <Stack gap={8} width="fit-content" alignItems="center">
                <Text variant="sm-medium">열람 횟수</Text>
                <Text variant="sm-semibold">{readCount}회</Text>
              </Stack>
            )}

            {Number(priorReadCount) > 0 && (
              <Flex width="fit-content" alignItems="center">
                <Text variant="sm-medium" color="zinc_400">
                  (이전버전 열람 {priorReadCount}회)
                </Text>
              </Flex>
            )}
            <Styled.Line />
            <Flex width="fit-content" alignItems="center">
              <Text variant="sm-semibold" marginRight={8} color="zinc_400">
                최근 열람
              </Text>
              <Text variant="sm-regular" color="zinc_400">
                {lastAction ? getUTCDate(lastAction, 'withYear') : '없음'}
              </Text>
            </Flex>
          </Stack>
        </Stack>
      </Stack>
    </Styled.BoxWrapper>
  );
};

export default Client;
